import { Controller } from "@hotwired/stimulus"

// Toggles visibility of two text blocks based on a checkbox state.
// Used for showing different descriptions when a toggle is on vs off.
export default class extends Controller {
  static targets = ["toggle", "enabledText", "disabledText"]

  update() {
    const isChecked = this.toggleTarget.checked
    this.enabledTextTarget.classList.toggle("hidden", !isChecked)
    this.disabledTextTarget.classList.toggle("hidden", isChecked)
  }
}
